import { render, staticRenderFns } from "./OrderWysiwyg.vue?vue&type=template&id=e61ef0ae&"
import script from "./OrderWysiwyg.vue?vue&type=script&lang=js&"
export * from "./OrderWysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports